import {
    createContext
} from "react";

export const ChartTableToggleContext = createContext<boolean>(false);
